import {Injectable, TemplateRef, HostListener} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'primeng/api';
import { isDevMode } from '@angular/core';

@Injectable()
export class ApiService {

  	url: string = "//pizzamitch.fr/api/index.php?";

  	export = new BehaviorSubject<boolean>(undefined);

	search = new BehaviorSubject<any>({});

	data = new BehaviorSubject<any>(undefined);

	user = new BehaviorSubject<any>(undefined);

	width = new BehaviorSubject<number>(window.innerWidth);

	imgs:any = [];
	
	screen:string;

	loading:boolean;


	constructor(private http:HttpClient, private notif: MessageService){}

	crypt(string){
		return string;
	}



	get(params){
		setTimeout(()=>{this.loading = true;});
		return this.http.get(this.url+this.crypt(params)).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	post(params,post){
		setTimeout(()=>{this.loading = true;});

		return this.http.post(this.url+this.crypt(params),post).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	success(mess){
		this.notif.add({severity:'success', summary:'Succès', detail:mess});
	}
	info(mess){
		this.notif.add({severity:'info', summary:'Info', detail:mess});
	}
	error(mess){
		this.notif.add({severity:'error', summary:'Erreur', detail:mess});
	}
	warning(mess){
		this.notif.add({severity:'warn', summary:'Attention', detail:mess});
	}

	log(mess){
		console.log(mess);
	}

}